// @flow

import React from "react";

import pdfFonts from "./assets/fonts/vfs_fonts";
import Button from "../Button";

import style from "./downloadPdf.scss";

const pdfMakePromise = import("pdfmake/build/pdfmake")
  .then(({ default: module }) => {
    return { ...module };
  })
  .catch(error => error);

type DownloadPdfType = {
  pdfData: any,
  generatePDFtemplate: () => {},
  downloadPdf?: () => {}
};

const fonts = {
  Brandon: {
    normal: "Brandon_reg.ttf",
    bold: "Brandon_bld.ttf"
  },
  Kepler: {
    light: "KeplerStd-LightDisp.ttf",
    normal: "KeplerStd-Disp.ttf"
  }
};

const DownloadPdf = ({ pdfData, generatePDFtemplate, downloadPdf }: DownloadPdfType) => {
  const buildPdf = async () => {
    const { template, fileName } = generatePDFtemplate(pdfData);
    const pdfMake = await pdfMakePromise;

    pdfMake.createPdf(template, null, fonts, pdfFonts).download(fileName);
  };

  return (
    <div className={style.wrapper}>
      <Button type="button" size="small" onClick={downloadPdf || buildPdf} theme="clean">
        Detailansicht ausdrucken
      </Button>
    </div>
  );
};

export default DownloadPdf;
